<span class="t-content">
  <ng-content></ng-content>
</span>
